import CommentComposer from './CommentComposer';
import CommentsScrollManager from './CommentsScrollManager';
import CommentsTabs from './CommentsTabs';
import { CommentsArea, CommentsScrollManagerWrapper, NewCommentsChip, Root } from './styles';
import useCommentsPanel from './vm';

interface Props {
  className?: string;
}

const CommentsPanel = ({ className }: Props) => {
  const { selectedTabMeta, setSelectedTabMeta } = useCommentsPanel();

  return (
    <Root className={className}>
      <CommentsTabs setSelectedTabMeta={setSelectedTabMeta} />
      <CommentsArea
        id={selectedTabMeta?.panelId}
        role={selectedTabMeta ? 'tabpanel' : 'none'}
        aria-labelledby={selectedTabMeta?.tabId}
      >
        <CommentsScrollManagerWrapper>
          <NewCommentsChip />
          <CommentsScrollManager />
        </CommentsScrollManagerWrapper>
        <CommentComposer />
      </CommentsArea>
    </Root>
  );
};

export default CommentsPanel;
